import { animate, animation, group, query, style, transition, trigger, useAnimation } from '@angular/animations';

export const scoreCardDetailsAnimationName = 'scoreCardDetailsPage';
export const conversationDataAnimationName = 'conversationDataPage';

const slideAnimation = animation([
  style({ position: 'relative' }),
  query(':enter, :leave', [style({ position: 'absolute', width: '100%', transform: 'translateX(0)' })]),
  query(':enter', [style({ transform: 'translateX({{ enterStart }})' })]),
  group([
    query(':leave', [animate('150ms ease-out', style({ transform: 'translateX({{ leaveEnd }})' }))]),
    query(':enter', [animate('150ms ease-out', style({ transform: 'translateX(0)' }))]),
  ]),
]);

export const conversationSlideInAndOutAnimation = trigger('routeAnimations', [
  transition(`${conversationDataAnimationName} => ${scoreCardDetailsAnimationName}`, [
    useAnimation(slideAnimation, { params: { enterStart: '100%', leaveEnd: '-100%' } }),
  ]),
  transition(`${scoreCardDetailsAnimationName} => ${conversationDataAnimationName}`, [
    useAnimation(slideAnimation, { params: { enterStart: '-100%', leaveEnd: '100%' } }),
  ]),
]);
